//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';

import { type AppState } from 'common/redux/reducers';
import { type WithRouterProps } from 'common/components/core/router';
import type { MasterOrderModelType } from 'common/models/flow/MasterOrder';

type PaginationInfoDataType = {
    currentPage: number,
    numberOfPages: number,
    total: number
};
export type OrdersDataType = {
    orders: Array<MasterOrderModelType>,
    paginationInfo: PaginationInfoDataType
};

class OrderMasterSelectors extends BaseEntitySelectors {
    constructor() {
        super('orderMaster');
    }

    getOrderFilterData(
        state: AppState,
        props: { ...WithRouterProps }
    ): ?OrdersDataType {
        const clientId = clientIdSelector(state, props);
        const { orderMaster } = state;
        return orderMaster.getIn([
            'filterRecords',
            clientId,
            'entities',
            'filterRecords'
        ]);
    }
}

export default (new OrderMasterSelectors(): OrderMasterSelectors);
